// extracted by mini-css-extract-plugin
export default {"usluge":"Projekti_usluge__80fXj"};